gz-info-box {
  &::part(container) {
    margin: 0;
  }
  &.form-max-width {
    max-width: 490px;
  }
}

.form-section {
  max-width: 490px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  flex-direction: column;

  gz-checkbox {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    width: auto;
  }

  &.form-section-wide {
    max-width: 100%;
  }
}

.form-subtitle {
  margin: calc(var(--spacer) * 1.5) 0 calc(var(--spacer) * 2) 0;
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.form-subtitle + .form-section {
  margin-top: calc(var(--spacer) * 2.5);
}

.form-section + .form-subtitle {
  margin-top: calc(var(--spacer) * 3.5);
}

.logo-img-container {
  width: 100%;
  height: 80px;

  background-color: var(--chart-101-pressed-dividers);

  border: 0;
  border-radius: 16px;

  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  .logo-img {
    display: block;
    max-width: 90%;
    max-height: 90%;

    &.hidden {
      display: none;
    }
  }
}

.logo-hint {
  margin: 8px 0 4px 4px;
}

.logo-buttons-container {
  display: flex;
  justify-content: space-between;
}

gz-button[id='mdr-contact-verify-email-button'] {
  &::part(button-text) {
    text-transform: none;
    font-size: var(--body-size-small);
  }
}

gz-mdr-contact-details-section {
  margin-top: calc(2 * var(--spacer));
  margin-bottom: calc(5 * var(--spacer));
}
